import { Layout, Space } from "antd";
import { Outlet } from "react-router-dom";
import classes from "./authLayout.module.css";
import Logo from "../Logo";

const { Content } = Layout;

const AuthLayout = () => {
  return (
    <Layout className={classes.root}>
      <Content className={classes.content}>
        <Space className={classes.logo}>
          <Logo/>
        </Space>
        <Outlet/>
      </Content>
    </Layout>
  );
};

export default AuthLayout;
